import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const documentTypeRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('document-types', {
      list: () => import(/* webpackChunkName: "admin" */ './Pages/List.vue'),
    })
      .except(['create', 'edit'])
      .permissions({
        list: 'document-types.view',
      })
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
